import React, { PropsWithChildren } from 'react';

import { Cross } from '@xsolla/ui-icons';

import { CloseButton, ContentWrapper, ModalWrapper, StyledModal } from './styles';

type Props = {
  onClose: () => void;
};

const Modal = ({ children, onClose }: PropsWithChildren<Props>): JSX.Element => {
  return (
    <ModalWrapper>
      <StyledModal>
        <ContentWrapper>
          <CloseButton onClick={onClose}>
            <Cross size={32} />
          </CloseButton>

          {children}
        </ContentWrapper>
      </StyledModal>
    </ModalWrapper>
  );
};

export default Modal;
